import { Component, OnInit, inject, ChangeDetectionStrategy } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { ButtonComponent } from "@components/button/button.component";
import { InputNumberComponent } from "@components/input-number/input-number.component";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ProduktFordelningsmatrisTyper } from "~app/common/models/constants";
import { ProduktDiameterfordelningDTO } from "~app/common/models/produkt/ProduktDiameterfordelningDTO";
import { ProduktLangdfordelningDTO } from "~app/common/models/produkt/ProduktLangdfordelningDTO";
import { IValidationContext } from "~app/common/validation/IValidationContext";
import { IValidationScope } from "~app/common/validation/IValidationScope";
import { ValidationScopes } from "~app/common/validation/ValidationScopes";
import { ProduktDetailTexts } from "~app/features/forsaljning/produkt/produkt-detail/produkt-detail.texts";
import { StringFormatPipe } from "../../../../../../../../../common/pipes/string-format.pipe";
import { LangdmodulModalValidation } from "./langdmodul-modal.validation";

@Component({
    selector: "rask-fordelningsmatris-langdmodul-modal",
    templateUrl: "./langdmodul-modal.component.html",
    styleUrls: ["./langdmodul-modal.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        InputNumberComponent,
        FormsModule,
        ButtonComponent,
        StringFormatPipe
    ]
})
export class FordelningsmatrisLangdmodulModalComponent implements OnInit {
    modal = inject(NgbActiveModal);

    diameterfordelningar: ProduktDiameterfordelningDTO[];
    title: string;
    min: number;
    max: number;
    inputLangd: number;

    langd: number;
    validation: IValidationScope;
    validationContext: IValidationContext;

    texts = ProduktDetailTexts.fordelningsmatrisTab.texts;

    get addOrEditButtonText() {
        return this.inputLangd ? this.texts.andra : this.texts.laggTill;
    }

    get canAdd() {
        return this.validationContext.hasErrors(ValidationScopes.spara);
    }

    ngOnInit(): void {
        this.langd = this.inputLangd ? this.inputLangd : 0;
        this.setupValidation();
    }

    addOrEdit(): void {
        if (this.inputLangd) {
            this.diameterfordelningar.forEach(df => {
                const lf = df.produktLangdfordelningar.find(p => p.langdBotten === this.inputLangd);
                lf.langdBotten = this.langd;
            });
        } else {
            if (this.diameterfordelningar.length > 0) {
                this.diameterfordelningar.forEach(df => {
                    df.produktLangdfordelningar.push({
                        andel: 0,
                        typ: ProduktFordelningsmatrisTyper.inget,
                        langdBotten: this.langd
                    } as ProduktLangdfordelningDTO);
                });
            }
        }

        return this.dismiss(true);
    }

    remove(): void {
        this.diameterfordelningar.forEach(df => {
            const dfIndex = df.produktLangdfordelningar.findIndex(p => p.langdBotten === this.inputLangd);
            df.produktLangdfordelningar.splice(dfIndex, 1);
        });

        this.dismiss(true);
    }

    dismiss(changesMade: boolean): void {
        if (changesMade) {
            return this.modal.close(changesMade);
        }

        this.modal.dismiss(changesMade);
        return undefined;
    }

    private readonly setupValidation = (): void => {
        this.validationContext = LangdmodulModalValidation.init(this.langd, this.diameterfordelningar, this.min, this.max);
        this.validationContext.scope(ValidationScopes.spara).subscribe(v => this.validation = v);
        this.validationContext.validate();
    };
}
